class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");

      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  cartUpdateUnsubscriber = undefined;
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      },
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
    );
  }

  onCartUpdate() {
    // Sepet sayfasında mıyız kontrol et
    const isCartPage = window.location.pathname === routes.cart_url;
    
    if (isCartPage) {
      // Sepet sayfasında ise sadece gerekli section'ları güncelle
      this.updateCartPageSections();
    } else {
      // Sepet drawer'da ise sadece drawer içeriğini güncelle
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const sourceQty = html.querySelector("cart-items");
          if (sourceQty) {
            this.innerHTML = sourceQty.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  updateCartPageSections() {
    // Sadece cart items'ı güncelle - footer otomatik güncellenir
    const cartItemsElement = document.getElementById("main-cart-items");
    if (!cartItemsElement) return;

    const sectionId = cartItemsElement.dataset?.id || "main-cart-items";
    
    fetch(`${routes.cart_url}?section_id=${sectionId}`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const newCartItems = html.getElementById("main-cart-items");
        if (newCartItems) {
          const targetElement = cartItemsElement.querySelector(".js-contents") || cartItemsElement;
          const newContent = newCartItems.querySelector(".js-contents") || newCartItems;
          if (targetElement && newContent) {
            targetElement.innerHTML = newContent.innerHTML;
          }
        }
        
        // Cart footer'ı da güncelle (fiyat bilgileri için)
        this.updateCartFooter();
        
        // Cart icon bubble'ı da güncelle
        this.updateCartIconBubble();
      })
      .catch(e => {
        console.error("Error updating cart items:", e);
      });
  }

  updateCartIconBubble() {
    const cartIconBubble = document.getElementById("cart-icon-bubble");
    if (cartIconBubble) {
      fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const newBubble = html.getElementById("cart-icon-bubble");
          if (newBubble) {
            cartIconBubble.innerHTML = newBubble.innerHTML;
          }
        })
        .catch(e => {
          console.error("Error updating cart icon bubble:", e);
        });
    }
  }

  getSectionsToRender() {
    const sections = [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items")?.dataset?.id || "main-cart-items",
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
    ];

    // main-cart-footer sadece varsa ekle
    const mainCartFooter = document.getElementById("main-cart-footer");
    if (mainCartFooter) {
      sections.push({
        id: "main-cart-footer",
        section: mainCartFooter.dataset?.id || "main-cart-footer",
        selector: ".js-contents",
      });
    }

    return sections;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        // Sepet sayfasında mıyız kontrol et
        const isCartPage = window.location.pathname === routes.cart_url;
        
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0,
          );

        // Sepet sayfasında ise section'ları güncelle
        if (isCartPage) {
          this.updateCartPageSections();
          return;
        }

        // Sepet drawer'da ise section'ları güncelle
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              ?.querySelector(section.selector) ||
            document.getElementById(section.id);
          if (elementToReplace && parsedState.sections[section.section]) {
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector,
              ) || "";
          }
        });
        
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue,
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`),
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name"),
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) {
          errors.textContent = window.cartStrings.error;
        }
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      if (message.length > 0) lineItemError.style.display = "flex";
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
    }

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      ?.querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`,
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden"),
    );



    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`,
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden"),
    );

  }

  updateCartFooter() {
    const cartFooterElement = document.querySelector(".wt-cart__footer-column #main-cart-footer");
    if (!cartFooterElement) return;

    // Cart.json'dan güncel fiyat bilgilerini al ve güncelle
    fetch(`${routes.cart_url}.js`)
      .then(response => response.json())
      .then(cart => {
        // Toplam fiyatı güncelle
        const totalPriceElements = cartFooterElement.querySelectorAll(".bcpo-cart-original-total");
        totalPriceElements.forEach(element => {
          // TL formatında göster (örn: 459.00TL)
          const priceInTL = (cart.total_price / 100).toFixed(2);
          element.textContent = `${priceInTL}TL`;
        });

        // İndirim bilgilerini güncelle
        const discountsContainer = cartFooterElement.querySelector(".discounts");
        if (discountsContainer) {
          if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
            // Mevcut indirimleri temizle ve yenilerini ekle
            discountsContainer.innerHTML = '';
            cart.cart_level_discount_applications.forEach(discount => {
              const discountElement = document.createElement('li');
              discountElement.className = 'discounts__discount discounts__discount--position';
              const discountAmount = (discount.total_allocated_amount / 100).toFixed(2);
              discountElement.innerHTML = `
                ${discount.title}
                (-${discountAmount}TL)
              `;
              discountsContainer.appendChild(discountElement);
            });
            discountsContainer.parentElement.style.display = 'block';
          } else {
            discountsContainer.parentElement.style.display = 'none';
          }
        }

        // Checkout butonunu güncelle (sepet boşsa disable et)
        const checkoutButton = cartFooterElement.querySelector(".wt-cart__cta");
        if (checkoutButton) {
          checkoutButton.disabled = cart.item_count === 0;
        }
      })
      .catch(e => {
        console.error("Error updating cart footer:", e);
      });
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({
              note: document.querySelector('[data-id="wt-cart-note"]').value,
            });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}
